/* ==========================================================
   CELLFY PDP — Carrossel infinito + scroll manual (sem zoom)
   ========================================================== */
(function () {
  'use strict';

  function init() {
    var viewport = document.querySelector('[data-cellfy-hs-viewport]');
    var track    = document.querySelector('[data-cellfy-hs-track]');
    if (!viewport || !track) return;

    /* === Auto-pausa quando o usuário interage manualmente === */
    var resumeTimer = null;
    function pauseAuto() {
      track.classList.add('is-paused');
      clearTimeout(resumeTimer);
    }
    function resumeAuto(delay) {
      clearTimeout(resumeTimer);
      resumeTimer = setTimeout(function () {
        track.classList.remove('is-paused');
      }, delay || 1500);
    }

    /* === Scroll manual (mouse drag) === */
    var isDown = false;
    var startX = 0;
    var scrollLeft = 0;

    viewport.addEventListener('mousedown', function (e) {
      isDown = true;
      viewport.classList.add('is-dragging');
      startX = e.pageX - viewport.offsetLeft;
      scrollLeft = viewport.scrollLeft;
      pauseAuto();
    });

    viewport.addEventListener('mouseleave', function () {
      if (!isDown) return;
      isDown = false;
      viewport.classList.remove('is-dragging');
      resumeAuto(2000);
    });

    viewport.addEventListener('mouseup', function () {
      isDown = false;
      viewport.classList.remove('is-dragging');
      resumeAuto(2000);
    });

    viewport.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      e.preventDefault();
      var x = e.pageX - viewport.offsetLeft;
      var walk = (x - startX) * 1.5;
      viewport.scrollLeft = scrollLeft - walk;
    });

    /* === Touch === */
    viewport.addEventListener('touchstart', function () { pauseAuto(); }, { passive: true });
    viewport.addEventListener('touchend', function () { resumeAuto(2500); }, { passive: true });

    /* === Wheel === */
    var wheelTimeout = null;
    viewport.addEventListener('wheel', function () {
      pauseAuto();
      clearTimeout(wheelTimeout);
      wheelTimeout = setTimeout(function () { resumeAuto(1500); }, 200);
    }, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();